import React, { useEffect } from 'react';
import useStorageStore from '../../stores/storageStore';
import diskIcon from '../../icons/icon-disk-100.png';
import { AccentButton } from './Button';

const StorageUsage = ({ onUpgradeClick, className = '' }) => {
  const {
    storageUsed,
    storageLimit,
    fetchStorageUsage,
    getStoragePercentage,
    formatBytes
  } = useStorageStore();

  useEffect(() => {
    fetchStorageUsage();
  }, [fetchStorageUsage]);

  const percentage = getStoragePercentage();
  const progressWidth = Math.min(percentage, 100);
  const isLowSpace = percentage >= 80;
  const progressBarColor = isLowSpace ? '#E46324' : '#4ABA62';

  return (
    <div className={`relative ${className}`}>
      {/* Disk Icon - positioned above the card */}
      <div className="absolute top-[-32px] left-1/2 transform -translate-x-1/2 z-10">
        <img 
          src={diskIcon} 
          alt="Storage" 
          className="w-16 h-16"
        />
      </div>

      {/* Card Container */}
      <div className="relative bg-[#FCFCFC] dark:bg-[#1A1A1A] border border-[#ECECEC] dark:border-[#202020] rounded-2xl shadow-[0_26px_38px_0_rgba(18,18,18,0.05)] overflow-hidden">
        {/* Top Section */}
        <div className="pt-10 pb-4 px-3 bg-white dark:bg-[#121212]">
          {/* Upgrade Message */}
          <p className="text-xs leading-4 text-[#7B7B7B] dark:text-[#848484] mb-6">
            Upgrade your plan to unlock more storage and keep your data.
          </p>

          {/* Progress Bar Section */}
          <div className="space-y-3.5">
            {/* Progress Bar */}
            <div className="w-full h-1.5 bg-[#F1F1F1] dark:bg-[#2A2A2A] rounded-xl overflow-hidden">
              <div
                className="h-full rounded-xl transition-all duration-300"
                style={{ width: `${progressWidth}%`, backgroundColor: progressBarColor }}
              />
            </div>

            {/* Progress Text */}
            <div className="flex items-center justify-between text-xs">
              <div className="flex items-center gap-1">
                <span className="font-medium text-[#121212] dark:text-[#D0D0D0]">
                  {formatBytes(storageUsed)}
                </span>
                <span className="text-[#7B7B7B] dark:text-[#848484]">of</span>
                <span className="font-medium text-[#121212] dark:text-[#D0D0D0]">
                  {formatBytes(storageLimit)}
                </span>
              </div>
              <span className="text-[#7B7B7B] dark:text-[#848484]">Used</span>
            </div>
          </div>
        </div>

        {/* Bottom Section with Button */}
        <div className="px-2 py-2 bg-[#FCFCFC] dark:bg-[#1A1A1A] border-t border-[#ECECEC] dark:border-[#202020]">
          <AccentButton variant="secondary" onClick={onUpgradeClick} className="w-full">Upgrade Storage</AccentButton>
        </div>
      </div>
    </div>
  );
};

export default StorageUsage;

